export const adminStackLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/home',
        },
        Admin_Notes: {
            path: 'admin/notes',
        },
        Admin_NoteEditor: {
            path: 'admin/notes/:noteID',
        },
        Admin_NoteTabHistory: {
            path: 'admin/notes/:noteID/tabs/:noteTabID/history',
        },
    },
};
export const adminTabsLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/*',
        },
    },
};
